import { makeStyles } from '@material-ui/styles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default makeStyles(() => ({
  menuProps: {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  },
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
  },
  labelCenter: {
    fontSize: 10,
    marginTop: 15,
    textAlign: 'center',
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '10',
  },
}));
